import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import BudgetModule from './BudgetModule.vue'
import ListBudgets from './views/ListBudgets.vue'
import CreateBudget from './views/CreateBudget.vue'
import ShowBudget from './views/ShowBudget.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/budgets',
    component: BudgetModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListBudgets',
        component: ListBudgets,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: '/budgets/:id/new',
        name: 'CreateBudget',
        component: CreateBudget,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: '/budgets/:id',
        name: 'ShowBudget',
        component: ShowBudget,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
